/* eslint-disable */
import http from "../../api/http"; /** file configured to make requests to the server with fetch */
import auth from "../../auth";
var _ = require("lodash");
const actions = {
     FetchUsers({commit},payload) {
        return http.get("users/"+payload.id_user, payload).then(response => {   
            return response;
        });
    },
    FetchUsersVolumes({commit},payload) {
        
        return http.get("users/"+auth.get_user_id()+"/volumes", payload).then(response => {   
            return response;
        });
    },
    FetchUsersScenes({commit},payload) {
        return http.get("users/"+auth.get_user_id()+"/scenes", payload).then(response => {   
            return response;
        });
    },
    FetchCreateAccount({},payload) {
        return http.post("userAccount", payload).then(response => {   
            return response;
        });
    }
};
export default actions;